/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

interface IAccountWishlistTileDescription {
    description: string;
}

// eslint-disable-next-line no-redeclare
const IAccountWishlistTileDescription: React.FC<IAccountWishlistTileDescription> = ({ description }) => (
    <p className='ms-account-wishlist-tile__description'>{description}</p>
);

export default IAccountWishlistTileDescription;
